import { useLinked, useModel } from "@type-r/react";
import React from "react";
import { UnappliedCashData } from "../../api/unappliedCash";
import { AssetsSection } from "../assets-section";
import { InblockedAssetsDataStep } from "../inblocked-assets-data-step";
import { InblockedAssetsTitle } from "../inblocked-assets-title";
import { UnappliedCashExternalSystems } from "./externalSystems";
import { UnappliedCashTile } from "./unapplied-cash-tile";

export const InblockedUnappliedCashesDataStep = ({ job, back, $assetTypeSelect, assetTypeMultiOptions, $refreshEvents, height }: { job, back?, $assetTypeSelect?, assetTypeMultiOptions?, $refreshEvents, height?}) => {
    const unappliedCashChanges = useModel(UnappliedCashData);
    const selectedunappliedCashChanges = useModel(UnappliedCashData);
    const $activeInvoice = useLinked(null);
    const $filter = useLinked({ search: '', eventType: null });
    const $loadedAssetEvents = useLinked(false);

    const $selectAllAssets = useLinked(false);

    return <InblockedAssetsDataStep
        assetName='Unapplied Cash'
        assetChanges={unappliedCashChanges}
        selectedAssets={selectedunappliedCashChanges}
        $filter={$filter}
        job={job}
        back={back}
        $loadedAssetEvents={$loadedAssetEvents}
        assetsListComponent={
            (filteredAssetChanges, itemsCount, $selectAllAssets, assetEventsGeneralCount) =>
                <AssetsSection
                    height={height ? height : 420}
                    title={<InblockedAssetsTitle assetChanges={unappliedCashChanges.items} externalSystems={UnappliedCashExternalSystems} $filter={$filter} $loadedAssetEvents={$loadedAssetEvents} importJobId={job.importJobId} itemsCount={itemsCount} assetEventsGeneralCount={assetEventsGeneralCount} />}
                    assets={filteredAssetChanges}
                    assetTile={UnappliedCashTile}
                    notExpanded={false}
                    $active={$activeInvoice}
                    selected={selectedunappliedCashChanges.items}
                    selectAllAssets={$selectAllAssets} />
        }
        externalSystems={UnappliedCashExternalSystems}
        $assetTypeSelect={$assetTypeSelect}
        assetTypeMultiOptions={assetTypeMultiOptions}
        $refreshEvents={$refreshEvents}
        selectAllAssets={$selectAllAssets} />
};
